<template>
    <div class="calendar-item-details calendar-item-details-short">
        <template v-if="isAppointment(item)"><!-- Appointment -->
            <div class="calendar-item-title">
                {{item.name}}
            </div>
        </template>

        <template v-else>
            <div class="calendar-item-title calendar-item-name">{{item.other_name}}</div>
            <div v-if="item.other_name != item.other_organisation_name" 
                class="calendar-item-organisation-name">{{item.other_organisation_name}}</div>
        </template>
    </div>
</template>
<script>
import {isAppointment} from '@/utils/Filter';

export default {
    name: 'CalendarItemDetailsShort',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        isAppointment,
    },
}
</script>
<style>
.calendar-item-details-short .calendar-item-name, 
.calendar-item-details-short .calendar-item-organisation-name {
    display: inline-block;
}
.calendar-item-details-short .calendar-item-name {
    margin-right: 5px;
}
.calendar-item-details-short .calendar-item-organisation-name::before {
    content: "(";
}
.calendar-item-details-short .calendar-item-organisation-name::after {
    content: ")";
}

</style>